export default () => {
  const TextWeight = {
    Unbounded_light: "Unbounded-Light",
    Raleway_Medium: "Raleway-Medium",
    Raleway_Bold: "Raleway-Bold",
    Raleway_SemiBold: "Raleway-SemiBold",
    Raleway_ExtraBold: "Raleway-ExtraBold",
    Segoe_UI: "Segoe UI",
  };

  return { TextWeight };
};
